import Title from "../Components/Title";
import React from "react";
import styled from "styled-components";
import { InnerLayout } from "../styles/Layouts";
import ServiceCard from "./ServiceCard";
import { People, WebRounded, BarChart, Code, WbIncandescentRounded } from '@material-ui/icons';

function ServicesSection() {
  return (
    <InnerLayout>
      <ServicesSectionStyled>
        <Title title={"My Skills"} span={"My Skills"} />
        <div className="services">
            <ServiceCard
              image={<WebRounded />}
              title={"Web Design"}
              paragraph={"--------------------------------------------"}
            />
            <ServiceCard
              image={<Code/>}
              title={"Web Development"}
              paragraph={"--------------------------------------------"}
            />
            <ServiceCard
              image={<BarChart/>}
              title={"Machine Learning"}
              paragraph={"--------------------------------------------"}
            />
            <ServiceCard
              image={<WbIncandescentRounded/>}
              title={"Data Structures and Algorithms"}
              paragraph={"--------------------------------------------"}
            />
            <ServiceCard
              image={<People/>}
              title={"Communication and Leadership"}
              paragraph={"--------------------------------------------"}
            />
        </div>
      </ServicesSectionStyled>
    </InnerLayout>
  );
}

const ServicesSectionStyled = styled.section`
  .services 
  {
    margin-top: 5rem;
    display: flex;
    flex-direction: column;
  }
  svg
  {
    font-size: 3rem;
  }
`;

export default ServicesSection;
